import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StockService } from 'app/sections/stocks/services/stock.service';
import { CryptoService } from 'app/sections/crypto/services/crypto.service';
import { Subscription } from 'rxjs';
import { Ticker } from 'app/interfaces/ticker';

@Component({
  selector: 'app-price-change',
  templateUrl: './price-change.component.html',
  styleUrls: ['./price-change.component.scss']
})
export class PriceChangeComponent implements OnDestroy, OnInit {
  @Input('type') type : 'stock' | 'crypto';
  public row: any = null;
  private shareTickerSubscription: Subscription;
  public loading: boolean = true;
  constructor(
    public stockService: StockService,
    public cryptoService: CryptoService) { }
  
  ngOnInit(): void {
    if(this.type === 'stock'){
      /* UPDATE PERCENTAGE CHANGE */
      this.shareTickerSubscription = this.stockService.shareTicker.subscribe((ticker: Ticker) =>{
        this.loading = true;
        if(ticker){
          ticker.previousClosePercentageChange = this.setPercentageChange(ticker, ticker.previousClose);
          ticker.oneMonthClosePercentageChange = this.setPercentageChange(ticker, ticker.oneMonthClose);
          ticker.oneWeekClosePercentageChange = this.setPercentageChange(ticker, ticker.oneWeekClose);
          ticker.oneYearClosePercentageChange = this.setPercentageChange(ticker, ticker.oneYearClose);
          ticker.threeMonthClosePercentageChange = this.setPercentageChange(ticker, ticker.threeMonthClose);
          ticker.threeYearClosePercentageChange = this.setPercentageChange(ticker, ticker.threeYearClose);
          ticker.fiveYearClosePercentageChange = this.setPercentageChange(ticker, ticker.fiveYearClose);
          setTimeout(() => {
            this.loading = false;
          }, 100);
        }
      });
    } else {
      this.shareTickerSubscription = this.cryptoService.shareTicker.subscribe((ticker: Ticker)=>{
        this.loading = true;
        if(ticker){ 
          ticker.previousClosePercentageChange = this.setPercentageChange(ticker, ticker.previousClose);
          ticker.oneMonthClosePercentageChange = this.setPercentageChange(ticker, ticker.oneMonthClose);
          ticker.oneWeekClosePercentageChange = this.setPercentageChange(ticker, ticker.oneWeekClose);
          ticker.oneYearClosePercentageChange = this.setPercentageChange(ticker, ticker.oneYearClose);
          ticker.threeMonthClosePercentageChange = this.setPercentageChange(ticker, ticker.threeMonthClose);
          ticker.threeYearClosePercentageChange = this.setPercentageChange(ticker, ticker.threeYearClose);
          ticker.fiveYearClosePercentageChange = this.setPercentageChange(ticker, ticker.fiveYearClose);
          setTimeout(() => {
            this.loading = false;
          }, 100);
        }
      });
    }
  }

  ngOnDestroy(){
    if(this.shareTickerSubscription) this.shareTickerSubscription.unsubscribe();
  }

  setPercentageChange(ticker: Ticker, price: number): number {
    return Number(((( ticker.price / price) - 1) * 100));
  }

}
